import React from "react";
import "./Media.css";

const Media = () => {
  return <div className="media">Media page in progress...</div>;
};

export default Media;
